const Twig = require('../../_utilities/twig-init');
/* eslint-disable import/no-unresolved */
const templates = JSON.parse(require('../../../dist/resources/widgets/templates.json').default);
const twigI18n = require('../../libs/twig/i18n');

let initialized = false;
const delayedPostMessage = (data) => {
  postMessage(data);
};
const process = (e) => {
  if (!initialized) {
    self.setTimeout(() => {
      process(e);
    }, 500);
    return;
  }

  console.info(`Twig Worker: Received render command for the ${e.data.id} widget`);

  Twig.twig({
    href: `${e.data.component}.twig`,
    method: 'ajax',
    allowInlineIncludes: true,
    autoescape: 'html',
    load: (template) => {
      let html = '';

      try {
        html = template
          .render(e.data.data)
          .trim()
          .replace(/<!--\[IF !IE]> -->/g, '')
          .replace(/<!-- <!\[ENDIF]-->/g, '');
      } catch (e) {
        console.error(e);
        return;
      }

      console.info(`Twig Worker: Successfully rendered the template for the ${e.data.id} widget`);

      delayedPostMessage({
        id: e.data.id,
        type: e.data.type,
        fingerprint: e.data.fingerprint,
        html,
      });
    },
  });
};

self.addEventListener('message', (e) => {
  switch (e.data.action) {
    default:
      break;

    case 'translationsResult':
      if (
        initialized
        || !e.data.result
      ) {
        return;
      }

      Twig.extendFilter('i18n', twigI18n(Twig, e.data.result));
      Twig.extend((Twig) => {
        Twig.Templates.registerLoader('ajax', function swingerLoader(location, params, successCallback) {
          const parser = this.parsers[params.parser] || this.parser.twig;

          params.url = location;
          params.data = templates[location];

          const template = parser.call(this, params);

          if (typeof successCallback === 'function') {
            successCallback(template);
          }

          return template;
        });
      });
      Twig.cache(true);
      initialized = true;
      break;

    case 'render':
      if (!e.data.id && e.data.type) {
        const uuid = Date.now();

        e.data.id = `${e.data.type}-${uuid}`;
      }

      if (e.data.id && !e.data.type) {
        e.data.type = e.data.id.split('-')[0];
      }

      process(e);
      break;
  }
});



// WEBPACK FOOTER //
// ./src/js/webworkers/twig-worker.js